import {
  DictionaryObject,
  Params,
  useAutocompleteSource,
  useFetch,
} from '@eas/common-web';
import { Decision } from '@models';
import { EvidenceApiUrl } from '@enums';

/**
 * List all available decision forms
 */
export function useDecisionForms() {
  return useFetch<DictionaryObject[]>(`${EvidenceApiUrl.DECISIONS}/form/list`, {
    method: 'GET',
  });
}

/**
 * List all available decision states
 */
export function useDecisionStates() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.DECISIONS}/state/list`,
    {
      method: 'GET',
      cacheResponse: true,
      cacheVersion: 1,
    }
  );
}

/**
 * List all available publish in collection states
 */
export function usePublishInCollection() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.DECISIONS}/publish-in-collection/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}

export function useDecisions(params?: Params) {
  return useAutocompleteSource<Decision>({
    url: `${EvidenceApiUrl.DECISIONS}/autocomplete`,
    params,
  });
}
